import React from "react";
import { Box, Typography, MenuItem } from "@mui/material";
import { grayLight, black, alabaster } from "design-system/colors";

// Style constants
const BORDER_RADIUS = "4px";
const PADDING_Y = 1.5;
const ICON_MARGIN_TOP = 0.5;
const CONTENT_MARGIN_LEFT = 1.5;
const SECONDARY_MARGIN_TOP = 2;
const SECONDARY_FONT_SIZE = "0.75rem";
const SECONDARY_LINE_HEIGHT = 1.3;
const PRIMARY_FONT_WEIGHT = 500;

type SearchResultItemProps = {
  icon: React.ReactNode;
  primaryText: string;
  secondaryText?: string | null;
  onClick: () => void;
  isSelected?: boolean;
};

function SearchResultItem({
  icon,
  primaryText,
  secondaryText,
  onClick,
  isSelected,
}: SearchResultItemProps) {
  return (
    <MenuItem
      onClick={onClick}
      selected={isSelected}
      sx={{
        borderRadius: BORDER_RADIUS,
        py: PADDING_Y,
        "&:hover": {
          backgroundColor: grayLight,
        },
        "&.Mui-selected": {
          backgroundColor: alabaster,
          "&:hover": {
            backgroundColor: alabaster,
          },
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        width="100%"
      >
        <Box mt={ICON_MARGIN_TOP} flexShrink={0}>
          {icon}
        </Box>
        <Box ml={CONTENT_MARGIN_LEFT} flex={1} overflow="hidden">
          <Typography
            style={{
              fontWeight: PRIMARY_FONT_WEIGHT,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            variant="body2"
          >
            {primaryText}
          </Typography>
          {secondaryText && (
            <Typography
              variant="caption"
              style={{
                display: "block",
                marginTop: SECONDARY_MARGIN_TOP,
                fontSize: SECONDARY_FONT_SIZE,
                lineHeight: SECONDARY_LINE_HEIGHT,
                color: black,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {secondaryText}
            </Typography>
          )}
        </Box>
      </Box>
    </MenuItem>
  );
}

export default SearchResultItem;